import Icon from '../components/Icon.vue'

Icon.register({
  bomb: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M440.5 88.5L388.5 140.5 415 167C424.4 176.4 424.4 191.6 415 200.9L397.6 218.3C409.4 244.4 416 273.4 416 303.9 416 418.8 322.9 511.9 208 511.9S0 418.9 0 304 93.1 96 208 96C238.5 96 267.5 102.6 293.6 114.4L311 97C320.4 87.6 335.6 87.6 344.9 97L371.4 123.5 423.4 71.5 440.5 88.5zM500 60H476C469.4 60 464 65.4 464 72S469.4 84 476 84H500C506.6 84 512 78.6 512 72S506.6 60 500 60zM440 0C433.4 0 428 5.4 428 12V36C428 42.6 433.4 48 440 48S452 42.6 452 36V12C452 5.4 446.6 0 440 0zM473.9 55L490.9 38C495.6 33.3 495.6 25.7 490.9 21 486.2 16.3 478.6 16.3 473.9 21L456.9 38C452.2 42.7 452.2 50.3 456.9 55 461.7 59.7 469.3 59.7 473.9 55zM406.1 55C410.8 59.7 418.4 59.7 423.1 55 427.8 50.3 427.8 42.7 423.1 38L406.1 21C401.4 16.3 393.8 16.3 389.1 21 384.4 25.7 384.4 33.3 389.1 38L406.1 55zM473.9 89C469.2 84.3 461.6 84.3 456.9 89 452.2 93.7 452.2 101.3 456.9 106L473.9 123C478.6 127.7 486.2 127.7 490.9 123 495.6 118.3 495.6 110.7 490.9 106L473.9 89zM112 272C112 236.7 140.7 208 176 208 184.8 208 192 200.8 192 192S184.8 176 176 176C123.1 176 80 219.1 80 272 80 280.8 87.2 288 96 288S112 280.8 112 272z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bomb.js
// module id = 1/1i
// module chunks = 144